/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 15:59:57
 * @LastEditTime: 2020-09-11 11:13:27
 * @Description: 用户api
 */
import axios from '@/utils/axios'

export const login = async (payload) => {
    return await axios.post(`/login`, payload)
}

export const logout = async () => {
    return await axios.post(`/logout`)
}

export const getMyInfo = async () => {
    return await axios.get('/userInfo')
}

export const resetMyPassword = (data) => {
    return axios.put(`/reset_my_password`, data)
}